import Layout from "../../Layout"

const KPIs = () => {

    return (
        <Layout>
            <div>

            </div>
        </Layout>
    )
}

export default KPIs